/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductTypeResponseDto>;
export function request(body: defs.basics.ProductTypeRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productType/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
